import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import mainreducer from './mainreducer';

export default combineReducers({
  mainreducer,
  form: formReducer,
});
